import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { IAgency, IAgencyPrintout } from '../../models/agency'
import { logout, selectRelation } from '../actions/constants'

export interface IAgencySlice {
  agency?: IAgency
  agencyPrintout?: IAgencyPrintout
}

const initialState: IAgencySlice = {
  agency: undefined,
  agencyPrintout: undefined
}

export const agencySlice = createSlice({
  name: 'agency',
  initialState,
  reducers: {
    setAgency: (state, action: PayloadAction<IAgency>) => {
      state.agency = action.payload
    },
    setAgencyPrintout: (state, action: PayloadAction<IAgencyPrintout|undefined>) => {
      state.agencyPrintout = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(logout, () => initialState)
      .addCase(selectRelation, () => initialState)
  }
})

export const {
  setAgency,
  setAgencyPrintout
} = agencySlice.actions

export default agencySlice.reducer
